import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { clearPatientDraftStorage } from "@/lib/patientStorage";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=anon

  useEffect(() => {
    const token = localStorage.getItem("bexley_token");
    if (!token) {
      setUser(null);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("bexley_token");
        setUser(null);
      });
  }, []);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { email: identifier, password });
    localStorage.setItem("bexley_token", data.token);
    setUser(data);
    return data;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("bexley_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    const currentUserId = user?.id;
    try {
      await api.post("/auth/logout");
    } catch {}
    clearPatientDraftStorage(currentUserId);
    localStorage.removeItem("bexley_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
